export default {
  emptyProfessionalProfile: ({ professional_profile }) => {
    return (
      Object.keys(professional_profile).filter(
        key =>
          professional_profile[key] != "" && professional_profile[key] != null
      ).length < 6
    );
  },
  isFilled: ({ professional_profile }) => {
    return (
      professional_profile.hasOwnProperty("id") &&
      professional_profile.id !== null &&
      (professional_profile.intended_remuneration !== null ||
        professional_profile.regimes.length > 0)
    );
  }
};
